import { render, staticRenderFns } from "./ClienteFilhosModal.vue?vue&type=template&id=8cb3c400"
import script from "./ClienteFilhosModal.vue?vue&type=script&lang=js"
export * from "./ClienteFilhosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports